module.exports = __webpack_public_path__ + "img/7-technicolor.d43a0a5.png";


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/assets/7-technicolor.png
// module id = xxgD
// module chunks = 1